const DEVICE = [1, 5, 118]
const TRUCK_MOVING = [8]
const CLOCK = [15, 16, 117]
const THERMOMETER = [17, 26]
const THERMOMETER_PLUS = [18, 151]
const TRUCK_IDLE = [30]
const DRIVER_FATIGUE = [50, 53]
const EYE_OFF = [51]
const DRIVER_CHANGE = [152]
const SMOKING = [54]
const PHONE_MISSED = [55]
const CRASH_DETECTION = [94, 95]
const SOS = [11]

export const getAlertIcon = (alertCode) => {
  if (DEVICE.includes(alertCode)) return 'outline_device'
  else if (TRUCK_MOVING.includes(alertCode)) return 'outline_truck-moving'
  else if (CLOCK.includes(alertCode)) return 'outline_clock'
  else if (THERMOMETER.includes(alertCode)) return 'outline_thermometer'
  else if (THERMOMETER_PLUS.includes(alertCode)) return 'outline_thermometer-plus'
  else if (TRUCK_IDLE.includes(alertCode)) return 'outline_truck-idle'
  else if (DRIVER_FATIGUE.includes(alertCode)) return 'fill_driver-fatigue'
  else if (EYE_OFF.includes(alertCode)) return 'fill_eye-off-2'
  else if (DRIVER_CHANGE.includes(alertCode)) return 'outline_driver'
  else if (SMOKING.includes(alertCode)) return 'outline_smoking'
  else if (PHONE_MISSED.includes(alertCode)) return 'outline_phone-missed'
  else if (CRASH_DETECTION.includes(alertCode)) return 'outline_crash-detection'
  else if (SOS.includes(alertCode)) return 'fill_sos'
  else return 'outline_alert-triangle'
}